import m from "../../../../geodata/es2015/region/world/oceaniaLow";
window.am4geodata_region_world_oceaniaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/oceaniaLow.js
// module id = null
// module chunks = 